interface IconProps {
  fillColor: string
}

export const AndroidSettingsErrorIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.6667 29.3279C12.6667 24.2874 16.7529 20.2012 21.7935 20.2012C25.5582 20.2012 28.7905 22.4805 30.1856 25.7345H63.3334C65.432 25.7345 67.1334 27.4358 67.1334 29.5345C67.1334 31.6332 65.432 33.3345 63.3334 33.3345H30V33.3265C28.5178 36.363 25.3999 38.4547 21.7935 38.4547C16.7529 38.4547 12.6667 34.3685 12.6667 29.3279ZM14.9334 29.3279C14.9334 25.5392 18.0048 22.4678 21.7935 22.4678C25.5822 22.4678 28.6536 25.5392 28.6536 29.3279C28.6536 33.1167 25.5822 36.188 21.7935 36.188C18.0048 36.188 14.9334 33.1167 14.9334 29.3279ZM30.7546 31.0678H63.3334C64.1802 31.0678 64.8667 30.3813 64.8667 29.5345C64.8667 28.6877 64.1802 28.0012 63.3334 28.0012H30.8245C30.8876 28.4343 30.9203 28.8773 30.9203 29.3279C30.9203 29.9229 30.8633 30.5046 30.7546 31.0678Z"
          fill={fillColor}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M58.2065 59.788C63.2471 59.788 67.3333 55.7018 67.3333 50.6613C67.3333 45.6207 63.2471 41.5345 58.2065 41.5345C54.6001 41.5345 51.4823 43.6262 50 46.6627V46.6547L16.6667 46.6547C14.568 46.6547 12.8667 48.356 12.8667 50.4547C12.8667 52.5534 14.568 54.2547 16.6667 54.2547L49.8144 54.2547C51.2095 57.5087 54.4418 59.788 58.2065 59.788ZM58.2065 57.5214C61.9953 57.5214 65.0666 54.45 65.0666 50.6613C65.0666 46.8725 61.9953 43.8012 58.2065 43.8012C54.4178 43.8012 51.3464 46.8725 51.3464 50.6613C51.3464 54.45 54.4178 57.5214 58.2065 57.5214ZM49.1755 51.988C49.1124 51.5549 49.0798 51.1119 49.0798 50.6613C49.0798 50.0663 49.1367 49.4846 49.2454 48.9214L16.6667 48.9214C15.8199 48.9214 15.1334 49.6078 15.1334 50.4547C15.1334 51.3015 15.8199 51.988 16.6667 51.988L49.1755 51.988Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
